import axios from "axios"
import { API_ROUTES } from "../utils/constants"

export function uploadBackup(file, token) {
    return new Promise((resolve, reject) => {
        const data = new FormData()
        data.append("file", file)

        let config = {
            method: "post",
            maxBodyLength: Infinity,
            headers: {
                "Content-Type": "multipart/form-data",
            },
            url: `${API_ROUTES.UPLOAD_PANEL_BACKUP}?token=${token}`,
            data,
        }

        axios
            .request(config)
            .then((res) => {
                resolve(res.data)
            })
            .catch((error) => {
                console.error(error)
                reject(error)
            })
    })
}
